<template>
	<div class="notice_popup">
		<div class="close">
			<img src="/images/close.png" alt="닫기" @click="$emit('close')"/>
		</div>
		<div class="tit">
			<span v-if="corpDivCd =='10'">클라이언트</span>
			<span v-else>파트너사</span>
			담당자 승인
		</div>

		<div class="member appr">
			<span class="name">{{mberInfo.mberNm}} ({{mberInfo.loginId}})</span> 님을
			<br/>
			<AutoComplete type="text" class="company" v-model="mberInfo.corpNm" :list="corpList" listText="corpNm" @autoComplete="setCorpInfo" title="회사명" rules= required >
				<template v-slot:autoComplete="autoComplete">{{autoComplete.item.corpNm}} / {{autoComplete.item.bizRegNo}}</template>
			</AutoComplete><nbsp/>의
			<br/> 
			담당자로 승인하시겠습니까?
		</div>
		
		<div class="select-btn">
			<div class="btn" @click="$emit('close', { mberStatusCd : '11', corpSeq : mberInfo.corpSeq })">승인불가</div>
			<div class="btn" @click="$emit('close', { mberStatusCd : '01', corpSeq : mberInfo.corpSeq })">승인</div>
		</div>
	</div>
</template>

<script>
export default {
	props:['param'],
	data() {
		return {
			mberInfo : this.param,
			corpList: [],
			corpDivCd : this.param.corpDivCd,
		}
	},

	beforeMount(){
		this.getCorpList();
	},
	methods : {
		getCorpList() {
			this.$.httpPost('/api/mem/adm/dco/getDcoScoCorpList', {corpDivCd : this.corpDivCd})
				.then(res => {
					this.corpList = res.data.corpList;
				}).catch(this.$.httpErrorCommon);
		},
		// 회사명 선택
		setCorpInfo(corpInfo) {
			if(corpInfo) {
				this.mberInfo.corpSeq = corpInfo.corpSeq;
				this.mberInfo.corpNm = corpInfo.corpNm;
				this.mberInfo.bizRegNo = corpInfo.bizRegNo;
			}else {
				this.mberInfo.corpSeq = '';
				this.mberInfo.corpNm = '';
				this.mberInfo.bizRegNo = '';
			}
		},
	}


}
</script>